import {Injectable, EventEmitter, Output} from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { GfxDynCompConfig } from "../components/gfx-host/gfx-dyn-comp-config";
import { ModalConfig } from "../components/gfx-modal/modal-config";
import {FormGroup} from '@angular/forms';
import {IGfxTriPagStateInfo} from '../components/gfx-list/models/i-gfx-tri-pag-state-info';
// import { ConfigGedFile } from "../components/gfx-ged/config-ged-file";

@Injectable({
  providedIn: "root",
})
export class SharingDataService {
  private mdlConfig: ModalConfig;
  private dynCompConfig: GfxDynCompConfig;
  private modalConfig = new BehaviorSubject(null);
  currentModalConfig = this.modalConfig.asObservable();
  private gfxDynCompConfig = new BehaviorSubject(null);
  currentGfxDynCompConfig = this.gfxDynCompConfig.asObservable();

  private dataMdl: any = null;
  public logOutEvent = new EventEmitter<any>();
  private dataModal = new BehaviorSubject(this.dataMdl);
  currentDataModal = this.dataModal.asObservable();

  public breadCrumb = new EventEmitter<any>();
  // breadCrumbEvent = this.dataModal.asObservable();

  private confGedFile: any[];
  private dataGedFile;
  currentDataGedFile;

  private sharedVariableInit: any = null;
  private sharedVariable = new BehaviorSubject(this.sharedVariableInit);
  currentSharedVariable = this.sharedVariable.asObservable();

  private filtersConfigInit: any = null;
  private filtrConfig = new BehaviorSubject(this.filtersConfigInit);
  currentFiltrConfige = this.filtrConfig.asObservable();

  private lastSearch = new BehaviorSubject([]);
  currentLastSearch = this.lastSearch.asObservable();

  private lastListUrl = new BehaviorSubject("");
  currentLastListUrl = this.lastListUrl.asObservable();

  private _lastFilterFrm: FormGroup;
  private triPagState: IGfxTriPagStateInfo[] = [];
  @Output() onListItemSelect = new EventEmitter<any>();
  
  public dataPrs = new EventEmitter<any>();
  public dataCheckGroad = new EventEmitter<any>();
  @Output() onWfTransitEvent = new EventEmitter<any>();
  @Output() onWfTransitFromGfxListEvent = new EventEmitter<any>();

  constructor() {
    this.initDataGedFile();
  }

  initDataGedFile() {
    this.dataGedFile = new BehaviorSubject(this.confGedFile);
    this.currentDataGedFile = this.dataGedFile.asObservable();
  }

  changeModalConfig(modalConf) {
    this.modalConfig.next(modalConf);
  }

  changeGfxDynConfig(gfxDynCompConf) {
    this.gfxDynCompConfig.next(gfxDynCompConf);
  }

  changeDataModal(mdlData) {
    this.dataModal.next(mdlData);
  }

  changeGedFileData(gedFileData: any[]) {
    this.dataGedFile.next(gedFileData);
  }

  changeSharedVariable(sharedVar) {
    this.sharedVariable.next(sharedVar);
  }

  changeFiltrConfig(config) {
    this.filtrConfig.next(config);
  }

  changeLastSearch(filters) {
    this.lastSearch.next(filters);
  }

  changeLastListUrl(filters) {
    this.lastListUrl.next(filters);
  }

  changeBreadCrumb(value) {
    this.breadCrumb.emit(value);
  }

  gedFileDataComplete() {
    //this.dataGedFile.complete();
  }

  getLastSearch() {
    return this.lastSearch.getValue();
  }

  getLastListUrl() {
    return this.lastListUrl.getValue();
  }

  getMdlConfig() {
    return this.modalConfig.getValue();
  }

  getGfxDynCompConfig() {
    return this.gfxDynCompConfig.getValue();
  }


  getTriPagStateByUrl(url): IGfxTriPagStateInfo {
    const triPagState = this.triPagState.filter(e => e.url === url);
    return triPagState.length ? triPagState[0] : null;
  }

  saveTriPagStateByUrl(triPagState: IGfxTriPagStateInfo) {
    triPagState.filterFrm = this.lastFilterFrm;
    this.triPagState = [];
    this.triPagState.push(triPagState);

    // const index = this.triPagState.map(function(e) { return e.url; })
    //     .indexOf(triPagState.url);

    // if (index >= 0) {
    //   this.triPagState[index] = triPagState;
    // } else {
    //   this.triPagState.push(triPagState);
    // }

  }

  initTriPagState() {
    this.triPagState = [];
    this.lastFilterFrm = undefined;
  }

  initTriPagStateOnNewListLoad(url) {
    const triPagState = this.triPagState.filter(e => e.url === url);
    if(!triPagState.length) {
      this.initTriPagState();
    }
  }

  get lastFilterFrm(): FormGroup {
    return this._lastFilterFrm;
  }

  set lastFilterFrm(value: FormGroup) {
    this._lastFilterFrm = value;
  }
  getDataModal() {
    return this.dataModal.getValue();
  }
}
